import * as v from 'valibot';
import { MIN_APY } from '../../constants';

const MIN_AMOUNT = 1;
const MAX_INIT_DEPOSIT = 1000000;

const MAX_APY = 9.99;

const MIN_AMOUNT_MESSAGE = MIN_AMOUNT.toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const apyMessage = `Please enter a number between ${MIN_APY} and ${MAX_APY}`;
const initialDepositMessage = `Please enter an amount between ${MIN_AMOUNT_MESSAGE} and ${MAX_INIT_DEPOSIT.toLocaleString(
  'en-US',
  {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
)}`;
const termLengthMessage = 'Please enter a term length';

const baseCdCalculatorFormSchema = v.object({
  initialDeposit: v.pipe(
    v.string(initialDepositMessage),
    v.minLength(1, initialDepositMessage),
    v.transform(input => {
      return (input as string).replace(/,/g, '');
    }),
    v.transform(Number),
    v.number(),
    v.minValue(MIN_AMOUNT, initialDepositMessage),
    v.maxValue(MAX_INIT_DEPOSIT, initialDepositMessage),
  ),
  annualPercentageYield: v.pipe(
    v.string(apyMessage),
    v.minLength(1, apyMessage),
    v.transform(Number),
    v.number(),
    v.minValue(MIN_APY, apyMessage),
    v.maxValue(MAX_APY, apyMessage),
  ),
  termLengthUnit: v.picklist(['months', 'years']),
  termLength: v.pipe(
    v.string(termLengthMessage),
    v.minLength(1, termLengthMessage),
    v.transform(Number),
    v.number(termLengthMessage),
    v.minValue(1),
  ),
});

export const cdCalculatorFormSchema = baseCdCalculatorFormSchema;
